import { HTTP } from '../services'

export default new (class QuoteService {
  // Send a quote via API
  sendQuote (quoteId) {
    return HTTP.post('/v1/quotes/' + quoteId + '/send')
  }

  // Get quote by ID
  getQuoteById (quoteId) {
    return HTTP.get('/v1/quotes/' + quoteId)
  }

  // Get quote by lead event ID, venue ID and version
  getQuoteByVersion (leadEventId, venueId, version) {
    return HTTP.get(`/v1/lead-event/${leadEventId}/quotes/venue/${venueId}/version/${version}`)
  }
})()